export const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
